import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

// Cart
// import { useShoppingCart } from 'use-shopping-cart';

// Components
import TimeArrow from '../text/timeArrow';
import DiscountedIcon from '../icons/discounted-icon';

// Utils
// import { checkStockLevels } from '../global/check-stock-levels';
import formatPrice from '../utility/formatPrice';
import { formatTitle } from '../utility/formatTitle';

const Card = styled.div`
  position: absolute;
  top: ${props => props.positionTop - 5 + 'px' || '-5px'};
  left: ${props => props.positionLeft - 5 + 'px' || '-5px'};

  width: ${props => props.width + 'px'};
  height: ${props => props.height + 5 + 'px'};

  font-family: 'Mabry-Medium';
  color: #fff;
  background-color: #3c82e6;

  box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.2);
  padding: 20px;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;

  & > a {
    text-decoration: none;
    color: inherit;
    position: relative;

    width: 100%;
  }

  z-index: 200;

  &:focus {
    outline: none;
  }
`;

const CardTitle = styled.h2`
  font-size: 22px;
  text-transform: uppercase;

  width: 100%;
  white-space: normal;

  color: ${props => props.textColor};

  margin: 0;
  // padding-bottom: 20px;
  width: 100%;
`;

const CardDetails = styled.div`
  font-size: 16px;
  line-height: 20px;

  padding: 0;
  width: 100%;

  align-self: flex-start;

  & > p {
    margin: 0;
  }
`;

const CardTimes = styled.div`
  display: flex;
`;

const CardPrice = styled.div`
  font-size: 16px;

  color: #fff;

  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;

  padding: 0;

  line-height: 1;

  @media (max-width: 820px) {
    min-height: 80px;
  }

  @media (max-width: 575px) {
    display: block;

    font-size: 13px;
    padding: 10px;
  }
`;

const PriceContainer = styled.div`
  display: flex;
  width: 180px;

  & > p:last-of-type {
    margin-left: 10px;
  }

  @media (max-width: 575px) {
    width: auto;
    flex-direction: column;
    align-items: flex-start;

    & > p:last-of-type {
      margin-left: 0;
    }
  }
`;

const FreePriceContainer = styled(PriceContainer)`
  & > p:last-of-type {
    margin-left: 0;
  }
`;

const Price = styled.p`
  margin: 0;
  cursor: pointer;
  border-bottom: 2px solid transparent;

  :hover {
    filter: invert(100%);
  }
`;

const SoldOutPriceContainer = styled(PriceContainer)`
  width: 233px;
`;

const SoldOutPrice = styled(Price)`
  cursor: initial;

  :hover {
    filter: unset;
  }
`;

const ActivePrice = styled.p`
  margin: 0;
  cursor: pointer;

  :hover {
    filter: invert(100%);
  }

  &:after {
    content: ' ';
    display: block;
    border-bottom: 2px solid #fff;
    padding-top: 3px;
  }

  @media (max-width: 575px) {
    &:after {
      padding-top: 1px;
      border-bottom-width: 1px;
    }
  }
`;

const AddToCart = styled.div`
  cursor: pointer;

  display: flex;
  flex-wrap: wrap;

  flex-direction: row;
  align-items: center;

  z-index: 200;

  & a {
    text-decoration: none;
  }

  :hover {
    filter: invert(100%);
  }

  & svg {
    margin-left: 5px;
  }

  @media (max-width: 575px) {
    align-items: flex-start;
  }
`;

const PartnerEventPrice = styled(Price)`
  cursor: initial;

  :hover {
    filter: unset;
  }
`;

const PartnerEventAddToCart = styled(AddToCart)`
  cursor: initial;

  :hover {
    filter: unset;
  }
`;

export const CalendarEventCard = ({
  details,
  link,
  positionTop,
  positionLeft,
  infoPanel,
  sku,
}) => {
  const [activePrice, setActivePrice] = useState('full_price');
  const [product, setProduct] = useState([]);

  // const [stockLevel, setStockLevel] = useState({
  //   isStockSet: false,
  //   stockLevel: null,
  //   stockType: '',
  // });

  // async function getStocksLevels() {
  //   const stockLevels = await checkStockLevels(sku);

  //   setStockLevel({
  //     isStockSet: true,
  //     stockLevel: stockLevels.currentInventory.inventory.quantity,
  //     stockType: stockLevels.currentInventory.inventory.type,
  //   });
  // }
  useEffect(() => {
    const formattedProductData = {
      name:
        activePrice === 'full_price'
          ? details.title.text
          : `${details.title.text} – Members Discount`,
      id: activePrice === 'full_price' ? `${sku}` : `${sku}_discounted`,
      price:
        activePrice === 'full_price'
          ? details.full_price * 100
          : details.discounted_price * 100,
      currency: 'GBP',
      image: details.image,
      uid: `/timetable/event/${link}`,
      details: details,
      productType: `event`,
    };

    setProduct(formattedProductData);
  }, [sku, details, link, activePrice, setProduct]);

  // useEffect(() => {
  //   getStocksLevels();
  // }, []);

  return (
    <Card
      positionTop={positionTop}
      positionLeft={positionLeft}
      width={infoPanel.width * 3}
      height={infoPanel.height * 2}
    >
      <Link to={'/timetable/event/' + link}>
        <CardTitle>{formatTitle(details.title.text)}</CardTitle>
      </Link>

      <CardDetails>
        <p>
          ■ <time dateTime={details.date}>{details.date}</time>{' '}
          {details.end_date && (
            <>
              <TimeArrow> → </TimeArrow>{' '}
              <time dateTime={details.end_date}>{details.end_date}</time>
            </>
          )}
        </p>
        <CardTimes>
          ● {details.start_time}
          <TimeArrow>&nbsp;→&nbsp;</TimeArrow>
          {details.finish_time}
        </CardTimes>

        <p>▲ {details.location.document.data.title.text}</p>
        <p>☀ {details.tutor.document.data.name.text}</p>
        {details.patreon_status !== 'Not Applicable' && (
          <>
            <br />
            <p>{details.patreon_status}</p>
          </>
        )}
      </CardDetails>

      {/* {stockLevel.stockLevel >= 1 || stockLevel.stockType === 'infinite' ? ( */}
      <CardPrice textColor={'#fff'}>
        {details.full_price > 0 && details.partner_event !== 'True' && (
          <>
            <PriceContainer>
              {activePrice === 'full_price' ? (
                <ActivePrice
                  color={'#fff'}
                  onClick={() => setActivePrice('full_price')}
                >
                  {formatPrice(details.full_price, 'gbp')}
                </ActivePrice>
              ) : (
                <Price onClick={() => setActivePrice('full_price')}>
                  {formatPrice(details.full_price, 'gbp')}
                </Price>
              )}

              {details.discounted_price && (
                <>
                  {activePrice === 'discounted_price' ? (
                    <ActivePrice
                      color={'#fff'}
                      onClick={() => setActivePrice('discounted_price')}
                    >
                      (<DiscountedIcon fill={'#fff'} />{' '}
                      {formatPrice(details.discounted_price, 'gbp')})
                    </ActivePrice>
                  ) : (
                    <Price onClick={() => setActivePrice('discounted_price')}>
                      (<DiscountedIcon fill={'#fff'} />{' '}
                      {formatPrice(details.discounted_price, 'gbp')})
                    </Price>
                  )}
                </>
              )}
            </PriceContainer>
            {details.eventbrite_link !== undefined && (
              <>
                {details.eventbrite_link.url !== '' && (
                  <AddToCart>
                    <a
                      href={details.eventbrite_link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Book Here
                    </a>
                  </AddToCart>
                )}
              </>
            )}{' '}
          </>
        )}

        {details.full_price <= 0 && (
          <>
            <FreePriceContainer>
              <SoldOutPrice>FREE</SoldOutPrice>
            </FreePriceContainer>

            {details.eventbrite_link !== undefined && (
              <>
                {details.eventbrite_link.url !== '' && (
                  <AddToCart>
                    <a
                      href={details.eventbrite_link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Book Here
                    </a>
                  </AddToCart>
                )}
              </>
            )}
            {/* <SoldOutPrice>
              Enquire <InfoIcon fill={'#fff'} />
            </SoldOutPrice> */}
          </>
        )}

        {details.full_price > 0 && details.partner_event === 'True' && (
          <>
            <PriceContainer>
              <PartnerEventPrice onClick={() => setActivePrice('full_price')}>
                {formatPrice(details.full_price, 'gbp')}
              </PartnerEventPrice>

              {details.discounted_price !== null && (
                <PartnerEventPrice
                  onClick={() => setActivePrice('discounted_price')}
                >
                  (<DiscountedIcon fill={'#fff'} />{' '}
                  {formatPrice(details.discounted_price, 'gbp')})
                </PartnerEventPrice>
              )}
            </PriceContainer>

            {details.eventbrite_link !== undefined && (
              <>
                {details.eventbrite_link.url !== '' && (
                  <AddToCart>
                    <a
                      href={details.eventbrite_link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Book Here
                    </a>
                  </AddToCart>
                )}
              </>
            )}

            {/* <PartnerEventAddToCart>
              Enquire <InfoIcon fill={'#fff'} />
            </PartnerEventAddToCart> */}
          </>
        )}
      </CardPrice>
      {/* ) : (
        <CardPrice textColor={'#fff'}>
          <SoldOutPriceContainer>
            <SoldOutPrice>
              {formatPrice(details.full_price, 'gbp')}
            </SoldOutPrice>

            {details.discounted_price && (
              <SoldOutPrice>
                (<DiscountedIcon fill={'#fff'} />{' '}
                {formatPrice(details.discounted_price, 'gbp')})
              </SoldOutPrice>
            )}
          </SoldOutPriceContainer>

          <SoldOutPrice>Sold Out</SoldOutPrice>
        </CardPrice>
      )} */}
    </Card>
  );
  // }
};

// export default CalendarEventCard;
